//LinkedIn Learning: Learning Full-Stack Javascript Development: MongoDB, Node, and React
//ES6
import * as ContactsAPI from '../utils/ContactsAPI';
import {getFromStorage, setInStorage, removeItem} from '../utils/storage.js'


  /********** Users **************/

  export function newUser(userFirstName, userLastName, userEMail, userPassword, userType, userOrganization, userLifeExpectancy, userBirthdate){

    const obj= getFromStorage('the_main_app')

    if (obj && obj.sessionID){

      ContactsAPI.newUser(obj.jwt,
        {
          userFirstName: userFirstName,
          userLastName: userLastName,
          userEMail: userEMail,
          userPassword: userPassword,
          userType: userType,
          userOrganization: userOrganization,
          userLifeExpectancy: userLifeExpectancy,
          userBirthdate: userBirthdate,

        }).then((user) => {
          console.log(`new contact added: ${user}`);

          var tempUsers = this.state.users;

          tempUsers.push(
            {
              _id: user._id,
              userFirstName: userFirstName,
              userLastName: userLastName,
              userEMail: userEMail,
              userPassword: userPassword,
              userType: userType,
              userOrganization: userOrganization,
              userLifeExpectancy: userLifeExpectancy,
              userBirthdate: userBirthdate,
            }
          )

          this.setState({users: tempUsers});

        });
    }
  }


   export function registerUser(userFirstName, userLastName, userEMail, userPassword, userType, userOrganization, userLifeExpectancy, userBirthdate){

      ContactsAPI.registerNewUser(
        {
          userFirstName: userFirstName,
          userLastName: userLastName,
          userEMail: userEMail,
          userPassword: userPassword,
          userType: userType,
          userOrganization: userOrganization,
          userLifeExpectancy: userLifeExpectancy,
          userBirthdate: userBirthdate,

        }).then((user) => {
          console.log(`new contact added: ${user}`);

          var tempUsers = this.state.users;

          tempUsers.push(
            {
              _id: user._id,
              userFirstName: userFirstName,
              userLastName: userLastName,
              userEMail: userEMail,
              userPassword: userPassword,
              userType: userType,
              userOrganization: userOrganization,
              userLifeExpectancy: userLifeExpectancy,
              userBirthdate: userBirthdate,
            }
          )

          this.setState({users: tempUsers});

        });
    
  }

  
  export function updateLoggedInUser(loggedInUser, userFirstName, userLastName, userEMail, userType, userOrganization, userLifeExpectancy, userBirthDate){
    
    var tempUserFirstName = "";
    var tempUserLastName = "";
    var tempUserEMail = "";
    var tempUserType = "";
    var tempUserOrganization = "";
    var tempUserLifeExpectancy = "";
    var tempUserBirthdate = "";

    if(userFirstName === ""){
      tempUserFirstName = loggedInUser.userFirstName;
    }else{
      tempUserFirstName = userFirstName;
    }

    if(userLastName === ""){
      tempUserLastName = loggedInUser.userLastName;
    }else{
      tempUserLastName = userLastName;
    }

    if(userEMail === ""){
      tempUserEMail = loggedInUser.userEMail;
    }else{
      tempUserEMail = userEMail;
    }

    if(userType === ""){
      tempUserType = loggedInUser.userType
    }else{
      tempUserType = userType;
    }

    if(userOrganization === ""){
      tempUserOrganization = loggedInUser.userOrganization
    }else{
      tempUserOrganization = userOrganization;
    }

    if(userLifeExpectancy === ""){
      tempUserLifeExpectancy = loggedInUser.userLifeExpectancy
    }else{
      console.log('lifeExpectancy in Users.js *********', userLifeExpectancy);
      tempUserLifeExpectancy = userLifeExpectancy;
    }
    
    if(userBirthDate === ""){
      tempUserBirthdate = loggedInUser.userBirthdate
    }else{
      console.log('birthDate in Users.js *********', userBirthDate);
      tempUserBirthdate = userBirthDate;
    }

    const obj= getFromStorage('the_main_app')

    if (obj && obj.sessionID){

      ContactsAPI.updateUser(obj.jwt, loggedInUser._id,
      {
        userFirstName: tempUserFirstName,
        userLastName: tempUserLastName,
        userEMail: tempUserEMail,
        userType: tempUserType,
        userOrganization: tempUserOrganization,
        userLifeExpectancy: tempUserLifeExpectancy,
        userBirthDate: tempUserBirthdate,

      }).then((user) => {
        console.log(`user updated: ${user}`);

        var tempUsers = this.state.users;

        tempUsers.map((user) => {
          if(loggedInUser._id === user._id){
            {

              user.userFirstName = tempUserFirstName;
              user.userLastName = tempUserLastName;
              user.userEMail = tempUserEMail;
              user.userType = tempUserType;
              user.userOrganization = tempUserOrganization;
              user.userLifeExpectancy = tempUserLifeExpectancy;
              user.userBirthDate = tempUserBirthdate;

            }
          }
        })

        this.setState({users: tempUsers});

      });
    }
  }


  export function editUser(selectedUser, userFirstName, userLastName, userEMail, userType, userOrganization, userLifeExpectancy, userBirthDate){
    
    var tempUserFirstName = "";
    var tempUserLastName = "";
    var tempUserEMail = "";
    var tempUserType = "";
    var tempUserOrganization = "";
    var tempUserLifeExpectancy = "";
    var tempUserBirthdate = "";

    if(userFirstName === ""){
      tempUserFirstName = selectedUser.userFirstName;
    }else{
      tempUserFirstName = userFirstName;
    }

    if(userLastName === ""){
      tempUserLastName = selectedUser.userLastName;
    }else{
      tempUserLastName = userLastName;
    }

    if(userEMail === ""){
      tempUserEMail = selectedUser.userEMail;
    }else{
      tempUserEMail = userEMail;
    }

    if(userType === ""){
      tempUserType = selectedUser.userType
    }else{
      tempUserType = userType;
    }

    if(userOrganization === ""){
      tempUserOrganization = selectedUser.userOrganization
    }else{
      tempUserOrganization = userOrganization;
    }

    if(userLifeExpectancy === ""){
      tempUserLifeExpectancy = selectedUser.userLifeExpectancy
    }else{
      console.log('lifeExpectancy in Users.js *********', userLifeExpectancy);
      tempUserLifeExpectancy = userLifeExpectancy;
    }
    
    if(userBirthDate === ""){
      tempUserBirthdate = selectedUser.userBirthdate
    }else{
      console.log('birthDate in Users.js *********', userBirthDate);
      tempUserBirthdate = userBirthDate;
    }

    const obj= getFromStorage('the_main_app')

    if (obj && obj.sessionID){

      ContactsAPI.updateUser(obj.jwt, selectedUser._id,
      {
        userFirstName: tempUserFirstName,
        userLastName: tempUserLastName,
        userEMail: tempUserEMail,
        userType: tempUserType,
        userOrganization: tempUserOrganization,
        userLifeExpectancy: tempUserLifeExpectancy,
        userBirthDate: tempUserBirthdate,

      }).then((user) => {
        console.log(`user updated: ${user}`);

        var tempUsers = this.state.users;

        tempUsers.map((user) => {
          if(selectedUser._id === user._id){
            {

              user.userFirstName = tempUserFirstName;
              user.userLastName = tempUserLastName;
              user.userEMail = tempUserEMail;
              user.userType = tempUserType;
              user.userOrganization = tempUserOrganization;
              user.userLifeExpectancy = tempUserLifeExpectancy;
              user.userBirthDate = tempUserBirthdate;

            }
          }
        })

        this.setState({users: tempUsers});

      });
    }
  }

  export function viewUser(userId){

      var tempUsers = this.state.users;

      tempUsers.map((user) => {
        if(userId === user._id){
          {
            this.setState(
              {
                selectedUser: user
              });
          }
        }
      });
  }

  export function getUser(userID){

    const obj= getFromStorage('the_main_app')

    if (obj && obj.sessionID){

      ContactsAPI.getUserWithId(obj.jwt, userID).then((response) => {

        if(response.status === 200){
          console.log(`user found`);
          console.log(`user: ${response}`);

          
        }

        //this.setState({users: filteredUsers});
      });
    }
  }

  export function deleteUser(userID){

    const obj= getFromStorage('the_main_app')

    if (obj && obj.sessionID){

      ContactsAPI.deleteUser(obj.jwt, userID).then((response) => {

        if(response.status === 200){
          console.log(`contact deleted`);

          var tempUsers = this.state.users;

          var filteredUsers = tempUsers.filter((user) => {
            if(user._id !== userID){
              return user;
            }
          });
        }

        this.setState({users: filteredUsers});
      });
    }
  }


  //Learning Resources
  //about fetch
  //https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
  //https://alligator.io/js/fetch-api/
  //https://developers.google.com/web/updates/2015/03/introduction-to-fetch
